import React from "react";
import './CompareAnswers.scss'
import * as constants from "../../../../const/constants";
import Header from "../../../../components/Header/Header";
import CardsFooter from "../../../../components/Modals/Footers/CardsFooter";
import {Button, Col, Container, Row} from "reactstrap";
import 'vimond-replay/index.css';
import * as actionModalCreator from "../../../../store/domain/modal/action";
import {connect} from "react-redux";
import {withRouter} from "react-router";
import * as actionSpinnerCreator from "../../../../store/domain/spinner/action";
import * as commonFunc from "../../../../utils/commonFunc";
import * as paperService from '../../../../services/papers';
import {lang, language} from "../../../../const/language";
import ViberHeader from "../../../../components/header-new/ViberHeader";


class ViewLeaderBoard extends React.Component {

    state = {

        lData: [],
        campareData: [],
        studentAnswer: [],
        teacherAnswers: [],
        newResult: new Array(0).fill().map((value, id) => (({
            id: id,
            answers: new Array(0).fill().map((value, id) => (({
                id: id,
                status: 0
            })))
        }))),
        oldResults: [],

    };

    componentDidMount() {
        this.viewComparison();
        this.setAnswerSheet();
    }

    setAnswerSheet = async (event) => {
        if (this.state.lData.data.totalQuestions !== 0) {
            await this.setState({
                // [event.target.name]: event.target.value,
                newResult: new Array(Number(this.state.lData.data.totalQuestions)).fill().map((value, id) => (({
                    id: id,
                    answers: new Array(Number(this.state.lData.data.totalAnswers)).fill().map((value, id) => (({
                        id: id,
                        status: 0
                    })))
                })))
            });
        }
    };

    viewComparison = async (paper) => {
        if (this.state.lData.data.flowType) {
            const data = {
                "classId": this.state.lData.data.classId,
                "quizId": this.state.lData.data.quizId,
                "enrollId": this.state.lData.data.enrollId,
            };
            console.log(data);
            await paperService.compareAnswers(data)

                .then(res => {
                    if (res.success) {
                        this.props.spinnerHandler(false);
                        this.setState({
                            campareData: res.body
                        });
                        this.setAnswersToArray()

                    } else {
                        commonFunc.notifyMessage(res.message);
                    }

                })
                .catch(error => {
                    console.log(error);
                    this.props.spinnerHandler(false);
                    commonFunc.notifyMessage(error.message, error.status);
                });
            this.props.spinnerHandler(false);
        }
        else {
            const data = {
                "quizId": this.state.lData.data.quizId,
                "courseId": this.state.lData.data.coursesId,
                "enrollId": this.state.lData.data.enrollId,
            };
            console.log(data);
            await paperService.compareCourseAnswers(data)

                .then(res => {
                    if (res.success) {
                        this.props.spinnerHandler(false);
                        this.setState({
                            campareData: res.body
                        });
                        this.setAnswersToArray()

                    } else {
                        commonFunc.notifyMessage(res.message);
                    }

                })
                .catch(error => {
                    console.log(error);
                    this.props.spinnerHandler(false);
                    commonFunc.notifyMessage(error.message, error.status);
                });
            this.props.spinnerHandler(false);

        }
    };

    async UNSAFE_componentWillMount() {
        let state = this.props.location.state;
        if (state) {

            await this.setState({
                lData: state,

            })
        } else {
            this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_VIEW_PAPER_ROUTE}`);
        }

        console.log(this.state.lData)
    }


    setAnswersToArray = () => {
        const nums = this.state.campareData.quizAnswers.split(';');
        console.log(nums);
        let answerArray = [];
        nums.map((body, index) => {

            this.state.oldResults[index] = body.split(',').map(n => parseInt(n, 10))

        });

        console.log(this.state.oldResults);
        this.setStuAnswersToArray()

    };

    setStuAnswersToArray = () => {
        const stAnswers = this.state.campareData.studentAnswers.split(';').map(n => parseInt(n, 10));
        this.setState({
            studentAnswer: stAnswers
        });
        console.log(this.state.studentAnswer)
    };


    render() {

        console.log(this.state.studentAnswer);
        console.log(this.state.teacherAnswers);


        return (
            <div>
                {/*<Header/>*/}
                <ViberHeader/>
                <main ref="main" className={"viewPaper"}>
                    <div className="backBtnHolder">
                        <button className={"home-btn"}
                                onClick={() => window.history.back()}>
                            <i className="icofont-long-arrow-left"/>
                            {language[lang].BackToTour}
                        </button>
                    </div>
                    <div className="trapezoid "></div>

                    <Container className={"comparison-container"}>
                        <Row>

                            <Col lg="6" sm="12" md="12">
                                <h3>{language[lang].comapreAnswerText}</h3>
                                <Row className={"btn-menu"}>
                                    <Col lg="1" md="1" sm="1" xm="1"> <Button className={"answer-btn-mobi "} style={{
                                        color: "white",
                                        background: "#35be1a"
                                    }}>1</Button>
                                    </Col>
                                    <Col lg="11" md="11" sm="11" xm="11"><h4>{language[lang].correctAnswerText}</h4>
                                    </Col>
                                </Row>


                                <Row className={"btn-menu"}>
                                    <Col lg="1" md="1" sm="1" xm="1">
                                        <Button className={"answer-btn-mobi "}
                                                style={{color: "white", background: "#F06334"}}>1</Button>
                                    </Col>
                                    <Col lg="11" md="11" sm="11" xm="11">
                                        <h4>{language[lang].wronfAnswerText}</h4>
                                    </Col>
                                </Row>
                                <Row className={"btn-menu"}>
                                    <Col lg="1" md="1" sm="1" xm="1">
                                        <Button className={"answer-btn-mobi "}
                                                style={{color: "white", background: "#bef034"}}>1</Button>
                                    </Col>
                                    <Col lg="11" md="11" sm="11" xm="11">
                                        <h4>{language[lang].undifinedAnswerText}</h4>
                                    </Col>
                                </Row>

                                <br/>
                                <br/>
                                <br/>
                            </Col>

                            {
                                this.state.newResult.map((obj, questionIndex) => {
                                    this.state.oldResults.map((items, outerIndex) => {

                                        if (questionIndex === outerIndex) {
                                            obj.answers.map((ans, answerIndex) => {
                                                items.map((item, innerIndex) => {

                                                    if ((item === answerIndex + 1) && (answerIndex + 1 !== this.state.studentAnswer[questionIndex])) {
                                                        this.state.newResult[questionIndex].answers[answerIndex].status = 2

                                                        //console.log("marking", item)
                                                    } else if ((item === answerIndex + 1) && (item === this.state.studentAnswer[questionIndex])) {


                                                        this.state.newResult[questionIndex].answers[answerIndex].status = 1
                                                        //console.log("correct", item)

                                                    } else if ((item === answerIndex + 1) && (item !== this.state.studentAnswer[questionIndex])) {
                                                        this.state.newResult[questionIndex].answers[answerIndex].status = 2

                                                        //console.log("marking", item)
                                                    } else if ((item !== answerIndex + 1) && (answerIndex + 1 === this.state.studentAnswer[questionIndex])) {
                                                        //console.log("wrong", item)
                                                        this.state.newResult[questionIndex].answers[answerIndex].status = 3

                                                    }
                                                    // else if ((item !== answerIndex + 1) &&(answerIndex+1 !== this.state.studentAnswer[questionIndex]))
                                                    //   {
                                                    //     this.state.newResult[questionIndex].answers[answerIndex].status = 4

                                                    //   //console.log("null", item)

                                                    // }

                                                })
                                            })
                                        }

                                    })

                                })
                            }

                            <Col lg="6" sm="12" md="12">
                                {this.state.newResult.map((obj, questionIndex) =>
                                    <div key={questionIndex}>
                                        <Row>
                                            <Col lg="12">
                                                <p className={"question-number-wrapper"}>
                                                    {
                                                        questionIndex + 1 < 10 ?
                                                            <span
                                                                className={"question-number"}>0{questionIndex + 1}. </span> :
                                                            <span
                                                                className={"question-number"}>{questionIndex + 1}. </span>

                                                    }
                                                    {obj.answers.map((ans, answerIndex) =>
                                                        <Button
                                                            className={"answer-btn "}
                                                            key={answerIndex}
                                                            checked={ans.condition}
                                                            style={{
                                                                background: ans.status === 1 ? "#35be1a "
                                                                    : ans.status === 3 ? "#F06334"
                                                                        : ans.status === 2 ? "#bef034" : "#cbcdcf",

                                                                color: ans.status === 1 ? "white "
                                                                    : ans.status === 2 ? "white"
                                                                        : ans.status === 3 ? "white" : "#293D60"
                                                            }}

                                                        > {answerIndex + 1} </Button>
                                                    )
                                                    }
                                                </p>
                                            </Col>
                                        </Row>
                                    </div>
                                )}


                            </Col>


                        </Row>
                    </Container>


                </main>

                <CardsFooter/>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({});


const mapDispatchToProps = (dispatch) => ({
    setPaymentModal: (data, value) => dispatch(actionModalCreator.setPaymentModal(data, value)),
    spinnerHandler: data => dispatch(actionSpinnerCreator.spinnerHandler(data)),

});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ViewLeaderBoard));

/* Created By Janitha Prashad Katukenda
 jpk Created on Thu Dec 10 2020
Copyright (c) 2020 Ceyentra Technologies
EDULAB */
